import * as React from "react";

import "./my-listings-error-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {DeprecatedModalService2}   from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const MyListingsErrorModal = ({back=false, isCC=false, next}) => DeprecatedModalService2({
    render: ({}, rm) => ({
        size: "small",
        content: ErrorModalContent({
            modal: {
                close: back ? () => window.history.back() : () => rm(),
            },
            isCC
        }),
    }),
    hideCloseButton: true,
    next,
});

const ErrorModalContent = ({modal, isCC}) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => (
        <div className="error-modal-box-g5t">
            <div className="title" style={{color: themeScheme.xpresso.menuBackgroundColor}}>
                My Listings
            </div>
            <div className="messages">
                <div className="message">
                    There is a problem with the listing that you have selected.
                </div>
                <div className="message">
                    Please select another listing.
                </div>
            </div>
            <div className="buttons">
                <button {...{
                    className: "button",
                    "xd-qa-type": "button",
                    "xd-qa-name": isCC ? "OK": "Return to My Listings",
                    onClick: () => modal.close(),
                }}>
                    <i className="fa fa-times"/>{" "}{isCC? "OK": "Return to My Listings"}
                </button>
            </div>
        </div>
    ),
);